import { EnrichmentExportOutputFormat, EnrichmentExportParams, EnrichmentExportScope } from "./enrichment";


export enum AsyncJobStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export enum AsyncJobType {
  ENRICHMENT_EXPORT = "ENRICHMENT_EXPORT",
  ENRICHMENT_UPLOAD = "ENRICHMENT_UPLOAD",
}

export interface EnrichmentExportMetadata {
  scope: EnrichmentExportScope;
  outputFormat: EnrichmentExportOutputFormat;
  dateFrom: string | null;
  dateTo: string | null;
  rowCount: number;
  outputBlobPath: string;
}

export type AsyncJob = {
  id: string,
  brand_id: string | null,
  error_message: string | null,
  status: AsyncJobStatus,
  created_at: string,
  updated_at: string,
  completed_at: string | null,
} & (
    {
      type: AsyncJobType.ENRICHMENT_EXPORT,
      metadata: EnrichmentExportMetadata,
    } | {
      type: AsyncJobType.ENRICHMENT_UPLOAD,
      metadata: any, // TODO: Add enrichment upload metadata
    }
  );

export interface AsyncJobsResponse {
  jobs: AsyncJob[];
  total: number;
  limit: number;
  offset: number;
}